import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';
import classnames from 'classnames';
import LazyTabPanel from '../../../components/LazyTabPanel';
import AggregatorSettings from './tabs/AggregatorSettings';
import AggregatorSignup from './tabs/AggregatorSignup';
import AggregatorBillingKpis from './tabs/AggregatorBillingKPIs';
import AggregatorFinch from './tabs/AggregatorFinch';

function AggregatorTabController({
  aggregator,
  setAggregator,
  setSpinner,
  changeChecked,
  changeValue,
  uniformUrls,
  openModal,
}) {
  const [activeTab, setActiveTab] = useState('signup');

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Tab.Container activeKey={activeTab}>
      <Row>
        <Col md={2} />
        <Col md={10} className="d-flex flex-column">
          <Nav className="bo-pointer mt-5" variant="tabs">
            {[
              { key: 'signup', name: 'Signup' },
              { key: 'settings', name: 'Settings' },
              { key: 'billing_kpis', name: 'Billing and KPIs' },
              { key: 'finch', name: 'Finch' },
            ].map(x => (
              <Nav.Item key={x.key}>
                <Nav.Link
                  className={classnames({ active: activeTab === x.key })}
                  onClick={() => toggle(x.key)}
                >
                  {x.name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Tab.Content className="bo-tabs">
            <LazyTabPanel activeTab={activeTab} tabId="signup">
              <AggregatorSignup
                aggregatorId={aggregator.id}
                aggregatorUseEmployeeIdProspects={aggregator.useEmployeeIdProspects}
                aggregatorHideEmployeeIdProspects={aggregator.hideEmployeeIdProspects}
                aggregatorAllowAnonymousSignups={aggregator.allowAnonymousSignups}
                aggregatorUseEmployeeIdAnonymous={aggregator.useEmployeeIdAnonymous}
                aggregatorMaxAllowedSignups={aggregator.maxAllowedSignups}
                setSpinner={setSpinner}
                changeChecked={changeChecked}
                changeValue={changeValue}
                uniformUrls={uniformUrls}
                openModal={openModal}
              />
            </LazyTabPanel>
            <LazyTabPanel activeTab={activeTab} tabId="settings">
              <AggregatorSettings
                aggregatorDefaultFreeCreditTransfers={aggregator.defaultFreeCreditTransfers}
                aggregatorDefaultFreeDebitTransfers={aggregator.defaultFreeDebitTransfers}
                aggregatorDefaultTransferFee={aggregator.defaultTransferFee}
                aggregatorDefaultBpInitQuota={aggregator.defaultBpInitQuota}
                aggregatorDefaultBpMonthlyQuota={aggregator.defaultBpMonthlyQuota}
                aggregatorDefaultBpCap={aggregator.defaultBpCap}
                aggregatorDefaultPostPaydayClusterExtension={
                  aggregator.defaultPostPaydayClusterExtension
                }
                aggregatorDefaultPrePaydayClusterExtension={
                  aggregator.defaultPrePaydayClusterExtension
                }
                changeValue={changeValue}
              />
            </LazyTabPanel>
            <LazyTabPanel activeTab={activeTab} tabId="billing_kpis">
              <AggregatorBillingKpis
                aggregatorMonthlySubscriptionFee={aggregator.monthlySubscriptionFee}
                aggregatorNumberOfEmployees={aggregator.numberOfEmployees}
                aggregatorNumberOfAddressableEmployees={aggregator.numberOfAddressableEmployees}
                aggregatorTurnoverBenchmerk={aggregator.turnoverBenchmerk}
                aggregatorTurnoverBenchmerkSource={aggregator.turnoverBenchmerkSource}
                aggregatorEmployeeReplacementCost={aggregator.employeeReplacementCost}
                aggregatorEmployeeReplacementCostSource={aggregator.employeeReplacementCostSource}
                aggregatorTurnoverCalculation={aggregator.turnoverCalculation}
                aggregatorTurnoverCalcForNonBillableStatus={
                  aggregator.turnoverCalcForNonBillableStatus
                }
                changeValue={changeValue}
                changeChecked={changeChecked}
              />
            </LazyTabPanel>
            <LazyTabPanel activeTab={activeTab} tabId="finch">
              <AggregatorFinch
                aggregatorId={aggregator.id}
                aggregatorFinchConnections={aggregator.finchConnections}
                setAggregator={setAggregator}
              />
            </LazyTabPanel>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

export default AggregatorTabController;
